// extracted by mini-css-extract-plugin
export default {"table":"LeasePopup_table__31ELV"};